export class ManageConfigurationModel {
    configurationId: string | undefined;
    groupId: string | undefined;
    groupName: string | undefined;
    productCode: string | undefined;
    configKey: string | undefined;
    value: string | undefined;
    name: string | undefined;
    configurationTypeCode: string | undefined;
    configurationMatrix: ConfigurationMatrix;
    configurationChildList: any[];
    description: string | undefined;
    isActive: boolean | undefined;
    
    constructor() {
        this.configurationMatrix = new ConfigurationMatrix();
        this.configurationChildList = [];
    }
}

export class ConfigurationMatrix {
    matrixId: string | undefined;
    hasValue: boolean | undefined;
    isActive: boolean | undefined;
    condition1: string | undefined;
    condition2: string | undefined;
    condition3: string | undefined;
    condition4: string | undefined;
    condition5: string | undefined;
}